module.exports = __webpack_public_path__ + "img/guide1-5.4ce6fb4c.png";